import CellValue from '@app/shared/components/cell-value/CellValue';
import { useAppSelector } from '@core/hooks/redux-hooks';
import {
  TABLE_COL_WIDTH,
  TABLE_LABELS_COL_WIDTH_OPM_INPUTS,
} from '@app/shared/constants/table-config';
import { shortDateViewRules } from '@app/shared/components/cell-value/CellValueConfigurations';
import styles from '../opm-inputs.module.scss';
import { useLocale } from '@app/core/hooks/useLocale';
import classNames from 'classnames';
import OpmInputHistoricCells from './OpmInputHistoricCells';
import { filterHistoricEventDatesFromFirstEvent } from '../utils/OpmInputHelper';

export const OpmInputTableHeader = () => {
  const project = useAppSelector((state) => state.project.projectDraft);
  const { l } = useLocale();
  const opmInputResults = useAppSelector((state) => state.opmCalculation.calculatedInputs);
  const showHistoricDataColumns = useAppSelector(
    (state) => state.uiValues.userSelections.opmInputs.showHistoricDataColumns
  );
  const historicColumnCount = Object.keys(
    filterHistoricEventDatesFromFirstEvent(opmInputResults?.historicEventDates ?? [])
  ).length;

  return (
    <>
      <colgroup>
        <col style={{ minWidth: `${TABLE_LABELS_COL_WIDTH_OPM_INPUTS}px` }} />
        {showHistoricDataColumns &&
          Array.from({ length: historicColumnCount }).map((_, index) => (
            <col key={`historic-col-${index}`} style={{ width: `${TABLE_COL_WIDTH}px` }} />
          ))}
        <col style={{ width: `${TABLE_COL_WIDTH}px` }} />
        {project.opmInput?.perYearInputs.map((_, index) => (
          <col key={`forecast-col-${index}`} style={{ width: `${TABLE_COL_WIDTH}px` }} />
        ))}
        <col />
      </colgroup>
      <thead
        className={`table-primary__sticky-section table-primary__sticky-section--opm-input-header ${
          styles[`opm-table-header`]
        }`}>
        <tr>
          <th className={`table-primary__cell--header-tertiary ${styles[`table-title`]}`}>
            {l('_OtherInputs')}
          </th>
          <OpmInputHistoricCells
            indexIdentifier="header-dates"
            className="table-primary__cell--header-tertiary"
            renderCell={(date) => <CellValue value={date} {...shortDateViewRules} />}
          />
          <th className={classNames('table-primary__cell--header-tertiary')}>
            <CellValue value={project.valuationDate} {...shortDateViewRules} />
          </th>
          {project.opmInput?.perYearInputs.map((forecast, index) => (
            <th key={index} className="table-primary__cell--header-tertiary">
              <CellValue value={forecast.forecastDate} {...shortDateViewRules} />
            </th>
          ))}
          <th className="table-primary__cell--header-tertiary" />
        </tr>
      </thead>
    </>
  );
};
